import router from '../../../router';

export default {
    state: {
        accessToken: localStorage.getItem('access_token') != null ? localStorage.getItem('access_token') : null,
        authUserInfo: localStorage.getItem('user_info') != null ? JSON.parse(localStorage.getItem('user_info')) : null,
        loginError: false,
        processing: false,
        forgotMailSuccess: null,
        resetPasswordSuccess: null
    },
    getters: {
        accessToken: state => state.accessToken,
        authUserInfo: state => state.authUserInfo,
        processing: state => state.processing,
        loginError: state => state.loginError,
        forgotMailSuccess: state => state.forgotMailSuccess,
        resetPasswordSuccess: state => state.resetPasswordSuccess,
    },
    mutations: {
        setToken(state, payload) {
            state.accessToken = payload;
            state.processing = false;
            state.loginError = null;
        },
        setAuthUserInfo(state, payload) {
            state.authUserInfo = payload;
        },
        setLogout(state) {
            state.accessToken = null
            state.processing = false
            state.loginError = null
        },
        setProcessing(state, payload) {
            state.processing = payload
            state.loginError = null
        },
        setError(state, payload) {
            state.loginError = payload
            state.accessToken = null
            state.processing = false
        },
        setForgotMailSuccess(state) {
            state.loginError = null
            state.accessToken = null
            state.processing = false
            state.forgotMailSuccess = true
        },
        setResetPasswordSuccess(state) {
            state.loginError = null
            state.accessToken = null
            state.processing = false
            state.resetPasswordSuccess = true
        },
        clearError(state) {
            state.loginError = null
        }
    },
    actions: {
        retrieveToken({commit}, payload) {
            commit('clearError');
            commit('setProcessing', true);

            axios.post('api/login', {
                username: payload.username,
                password: payload.password,
            })
                .then(user => {
                    const accessToken = user.data.access_token;
                    if (accessToken !== undefined || true) {
                        localStorage.setItem('access_token', accessToken);

                        setTimeout(() => {
                            commit('setToken', accessToken);
                        }, 1000);
                    }
                })
                .catch(error => {
                    if (error.response.status === 422) {
                        localStorage.removeItem('access_token');
                        commit('setError', error.response.data.errors);
                        setTimeout(() => {
                            commit('setError', false)
                        }, 3000);
                    } else if (error.response.status === 401) {
                        localStorage.removeItem('access_token');
                        commit('setError', error.response.data.errors.credential);
                        setTimeout(() => {
                            commit('setError', false)
                        }, 3000);
                    } else if (error.response.status === 500) {
                        localStorage.removeItem('access_token');
                        commit('setError', error.response.data.errors.server);
                        setTimeout(() => {
                            commit('setError', false)
                        }, 3000);
                    } else {
                        localStorage.removeItem('access_token');
                        commit('setError', 'Could not reach server, please try again.');
                        setTimeout(() => {
                            commit('setError', false)
                        }, 3000);
                    }
                });
        },
        retrieveAuthUserInfo({commit}) {
            const authUserInfo = JSON.parse(localStorage.getItem('user_info'));
            commit('setAuthUserInfo', authUserInfo);
        },
        forgotPassword({commit}, payload) {
            commit('clearError');
            commit('setProcessing', true);
            // firebase
            //     .auth()
            //     .sendPasswordResetEmail(payload.email)
            //     .then(
            //         user => {
            //             commit('clearError');
            //             commit('setForgotMailSuccess')
            //         },
            //         err => {
            //             commit('setError', err.message);
            //             setTimeout(() => {
            //                 commit('clearError')
            //             }, 3000)
            //         }
            //     )
        },
        resetPassword({commit}, payload) {
            commit('clearError');
            commit('setProcessing', true);
        },


        /*
           return await auth.(resetPasswordCode, newPassword)
            .then(user => user)
            .catch(error => error);
        */
        signOut({commit}) {
            axios.post('/api/logout', {})
                .finally(response => {
                    localStorage.removeItem('access_token');
                    localStorage.removeItem('user_info');
                    commit('setError', false);
                    commit('setProcessing', false);
                    router.push('/login');
                });
        }
    }
}
